import {Injectable} from '@angular/core';
import {DocumentModel} from '../models/document.model';
import {CustomerModel} from '../models/customer.model';
import {ContactModel} from '../models/contact.model';
import {SiteModel} from '../models/site.model';
import {DetaillineDTOModel} from '../models/detaillineDTO.model';
import {ServiceJobDTOModel} from '../models/service-job-DTO.model';
import {ConfigurationService} from './configuration.service';
import {MeterReadingDTOModel} from '../models/meter-reading-DTO.model';
import {OperatorModel} from '../models/operator.model';
import {WsTaskDTOModel} from '../models/ws-task-DTO.model';
import {TimeClockingDTOModel} from '../models/time-clocking-DTO.model';
import {GenerateCustomerRefService} from './generate-customer-ref.service';
import {SimpleEngineerBeanModel} from '../models/simple-engineer-bean.model';
import {LokijsService} from './database/lokijs.service';
import {QueueStatus} from '../definitions/queue-status';

@Injectable({
    providedIn: 'root'
})
export class NewDocumentService {

    private newDocument: DocumentModel = new DocumentModel();
    private serviceJob: ServiceJobDTOModel = new ServiceJobDTOModel();

    constructor(private configService: ConfigurationService,
                private genCustomerRef: GenerateCustomerRefService,
                private loki: LokijsService,
                private queueStatus: QueueStatus) {
    }


    public genNewDocument(): DocumentModel {

        this.newDocument = new DocumentModel();
        this.newDocument.documentNumber = 0;
        this.newDocument.documentType = 0;
        this.newDocument.originalDocumentType = 0;
        this.newDocument.customer = new CustomerModel();
        this.newDocument.site = new SiteModel();
        this.newDocument.contact = new ContactModel();
        this.newDocument.selectedPlant = new DetaillineDTOModel();
        this.newDocument.extras = {};
        this.newDocument.equipment = new Array<DetaillineDTOModel>();
        this.newDocument.creationDate = new Date().toISOString();
        this.newDocument.scheduledDate = new Date().toISOString();
        this.newDocument.comment = '';
        this.newDocument.customerRef = this.genCustomerRef.generateCustRef();
        this.newDocument.lat = 0;
        this.newDocument.lng = 0;
        this.newDocument.selectedOperator = '' + this.configService.getConfiguration().selectedOperator;
        this.newDocument.selectedProductType = {};
        this.newDocument.selectedMeterType = {};
        this.newDocument.productTypes = [];
        this.newDocument.originalDetailLines = new Array<DetaillineDTOModel>();
        this.newDocument.detailLines = [];
        this.newDocument.requiredLines = [];
        this.newDocument.selectedDetailLine = {};
        this.newDocument.photosURL = [];
        this.newDocument.photosBase64 = [];
        this.newDocument.detailLineLocations = [];
        this.newDocument.selectedPhotoLocation = {};
        this.newDocument.selectedSalesPerson = 0;
        this.newDocument.location = this.configService.getConfiguration().selectedDepot;
        this.newDocument.policy = '';
        this.newDocument.calendar = '';
        this.newDocument.priceList = '';
        this.newDocument.tender = '';
        this.newDocument.discount = '';
        this.newDocument.discHire = 0.00;
        this.newDocument.discSale = 0.00;
        this.newDocument.customerOrderNo = '';
        this.newDocument.clockingState = 1;
        this.newDocument.signature = null;
        this.newDocument.engineerSignature = null;
        this.newDocument.operator = new OperatorModel();
        this.newDocument.showCustomer = false;
        this.newDocument.showSite = false;
        this.newDocument.showContact = false;
        this.newDocument.showJobTasks = false;
        this.newDocument.showTimeLogged = false;
        this.newDocument.completedDocument = true;
        this.newDocument.signatureContact = new ContactModel();
        this.newDocument.localClockingHistory = [];
        this.newDocument.selectedOperator = '' + this.configService.getConfiguration().selectedOperator;
        this.newDocument.timeClockingDTO = new Array<TimeClockingDTOModel>();
        this.newDocument.parentDocument = null;
        this.newDocument.queuedToOperatorId = null;
        this.newDocument.queueStatus = this.queueStatus.UNSYNCED;

        return this.newDocument;
    }

    public buildServiceJobDocumentBean(serviceJob: ServiceJobDTOModel) {
        this.newDocument = this.genNewDocument();
        this.newDocument.documentType = 7;
        const emptyJobCertBean = {
            id: 0,
            name: 'none'
        };
        console.log(serviceJob);

        if (!serviceJob.jobCertificateTextId) {
            serviceJob.jobCertificateTextId = emptyJobCertBean.id;
        }

        if (serviceJob.spares) {
            for (const spare of serviceJob.spares) {
                spare.comment = spare.description;
            }
        }

        this.newDocument.customer = serviceJob.cust;
        this.newDocument.site = serviceJob.site;
        this.newDocument.contact = serviceJob.contact;
        this.newDocument.serviceJob = serviceJob;
        this.newDocument.comment = serviceJob.noteText;
        this.newDocument.documentNumber = serviceJob.id;
        if( serviceJob.id === 0 ){
            this.newDocument.customerRef = this.genCustomerRef.generateCustRef();
        }else{
            this.newDocument.customerRef = serviceJob.id;
        }
        this.newDocument.detailLines = serviceJob.spares;
        this.newDocument.comment = serviceJob.noteText;

        return this.newDocument;


    }

    public buildNewServiceJobObj() {

        this.serviceJob = new ServiceJobDTOModel();

        this.serviceJob.complete = null;
        this.serviceJob.completedJob = false;
        this.serviceJob.contact = new ContactModel();
        this.serviceJob.cust = new CustomerModel();
        this.serviceJob.depot = this.configService.getConfiguration().selectedDepot;
        this.serviceJob.engineer = this.findEngineer();
        this.serviceJob.freeText = null;
        this.serviceJob.id = 0;
        this.serviceJob.jobNumber = 0;
        this.serviceJob.jobStatus = 1;
        this.serviceJob.jobType = null;
        this.serviceJob.jobTypeId = 1;
        this.serviceJob.manualRef = 0;
        this.serviceJob.meterReadings = new Array<MeterReadingDTOModel>();
        this.serviceJob.noteText = '';
        this.serviceJob.operator = this.findOperator();
        this.serviceJob.projectId = null;
        this.serviceJob.scheduledDate = new Date().toISOString();
        this.serviceJob.start = new Date().toISOString();
        this.serviceJob.servicedItem = new DetaillineDTOModel();
        this.serviceJob.site = new SiteModel();
        this.serviceJob.spares = new Array<DetaillineDTOModel>();
        this.serviceJob.start = null;
        this.serviceJob.tasks = new Array<WsTaskDTOModel>();
        

        return this.serviceJob;
    }

    private findEngineer(): SimpleEngineerBeanModel {
        const eng = this.loki.getCollection('engineer').chain()
            .find({id: this.configService.getConfiguration().selectedEngineer}).data()[0];
        return eng ? eng : new SimpleEngineerBeanModel();
    }

    private findOperator(): OperatorModel {
        const operator = this.loki.getCollection('operator').chain()
            .find({cod: this.configService.getConfiguration().selectedOperator}).data()[0];
        return operator ? operator : new OperatorModel();
    }
}
